module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-navigate-bar/home-navigate-bar.component.sass
// module id = ./src/app/modules/home/components/home-navigate-bar/home-navigate-bar.component.sass
// module chunks = main